/* eslint-disable */
// Support component names relative to this directory:
var branchesContext = require.context('branches', true);
var sharedComponentsContext = require.context('components', true);

var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContexts([branchesContext, sharedComponentsContext]);
